import { __assign } from "tslib";
import React from 'react';
import { IS_BROWSER, SC_ATTR, SC_ATTR_VERSION, SC_VERSION } from '../constants';
import StyleSheet from '../sheet';
import styledError from '../utils/error';
import { joinStringArray } from '../utils/joinStrings';
import getNonce from '../utils/nonce';
import { StyleSheetManager } from './StyleSheetManager';
var CLOSING_TAG_R = /^\s*<\/[a-z]/i;
var ServerStyleSheet = /** @class */ (function () {
    function ServerStyleSheet() {
        var _this = this;
        this._emitSheetCSS = function () {
            var css = _this.instance.toString();
            var nonce = getNonce();
            var attrs = [
                nonce && "nonce=\"".concat(nonce, "\""),
                "".concat(SC_ATTR, "=\"true\""),
                "".concat(SC_ATTR_VERSION, "=\"").concat(SC_VERSION, "\""),
            ];
            var htmlAttr = joinStringArray(attrs.filter(Boolean), ' ');
            return "<style ".concat(htmlAttr, ">").concat(css, "</style>");
        };
        this.getStyleTags = function () {
            if (_this.sealed) {
                throw styledError(2);
            }
            return _this._emitSheetCSS();
        };
        this.getStyleElement = function () {
            var _a;
            if (_this.sealed) {
                throw styledError(2);
            }
            var props = (_a = {},
                _a[SC_ATTR] = '',
                _a[SC_ATTR_VERSION] = SC_VERSION,
                _a.dangerouslySetInnerHTML = {
                    __html: _this.instance.toString(),
                },
                _a);
            var nonce = getNonce();
            if (nonce) {
                props.nonce = nonce;
            }
            // v4 returned an array for this fn, so we'll do the same for v5 for backward compat
            return [React.createElement("style", __assign({}, props, { key: "sc-0-0" }))];
        };
        this.seal = function () {
            _this.sealed = true;
        };
        this.instance = new StyleSheet({ isServer: true });
        this.sealed = false;
    }
    ServerStyleSheet.prototype.collectStyles = function (children) {
        if (this.sealed) {
            throw styledError(2);
        }
        return React.createElement(StyleSheetManager, { sheet: this.instance }, children);
    };
    // @ts-expect-error alternate return types are not possible due to code transformation
    ServerStyleSheet.prototype.interleaveWithNodeStream = function (input) {
        if (!__SERVER__ || IS_BROWSER) {
            throw styledError(3);
        }
        else if (this.sealed) {
            throw styledError(2);
        }
        if (__SERVER__) {
            this.seal();
            var Transform = require('stream').Transform;
            var readableStream = input;
            var _a = this, sheet_1 = _a.instance, _emitSheetCSS_1 = _a._emitSheetCSS;
            var transformer_1 = new Transform({
                transform: function appendStyleChunks(chunk, 
                /* encoding */
                _, callback) {
                    // Get the chunk and retrieve the sheet's CSS as an HTML chunk,
                    // then reset its rules so we get only new ones for the next chunk
                    var renderedHtml = chunk.toString();
                    var html = _emitSheetCSS_1();
                    sheet_1.clearTag();
                    // prepend style html to chunk, unless the start of the chunk is a
                    // closing tag in which case append right after that
                    if (CLOSING_TAG_R.test(renderedHtml)) {
                        var endOfClosingTag = renderedHtml.indexOf('>') + 1;
                        var before = renderedHtml.slice(0, endOfClosingTag);
                        var after = renderedHtml.slice(endOfClosingTag);
                        this.push(before + html + after);
                    }
                    else {
                        this.push(html + renderedHtml);
                    }
                    callback();
                },
            });
            readableStream.on('error', function (err) {
                // forward the error to the transform stream
                transformer_1.emit('error', err);
            });
            return readableStream.pipe(transformer_1);
        }
    };
    return ServerStyleSheet;
}());
export default ServerStyleSheet;
//# sourceMappingURL=ServerStyleSheet.js.map